import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
import FirebaseAuthService from './services/firebase'
import './registerServiceWorker'
import './global.scss'
import "./assets/styles/global.css"
import i18n from './services/i18n'
import HighchartsVue from 'highcharts-vue'

import {
  Avatar, TreeSelect, Rate, Breadcrumb, InputNumber, Steps, Message,
  Upload, Button, Layout, Table, Icon, Progress, Radio, Dropdown, Menu,
  Carousel, Input, Calendar, Badge, Slider, Form, Tooltip, Select, Switch,
  Tag, Affix, Spin, Alert, Checkbox, Tabs, Pagination, notification, Drawer,
  Modal, popconfirm, Row, Col, Collapse, message,DatePicker
} from 'ant-design-vue'

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAhPiWRrZe2pupb-OKqLqHZUeH1Gqg2VyA",
    libraries: "places",
    region: 'VI',
    language: 'vi',
  }
});

Vue.use(HighchartsVue)
Vue.use(Avatar)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(DatePicker)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Modal)
Vue.use(Switch)
Vue.use(popconfirm)
Vue.use(notification)
Vue.use(Row)
Vue.use(Col)
Vue.use(Collapse)

Vue.prototype.$notification = notification
Vue.prototype.$message = message

Vue.use(NProgress)
Vue.use(FirebaseAuthService)
Vue.use(VuePageTitle, {
  prefix: 'GoDate | ',
  router,
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

window.onAuthStateChanged = () => {
  new Vue({
    router,
    store,
    nprogress,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}
